import {
  Component,
  inject,
  Renderer2,
  type OnDestroy,
  type OnInit,
  ChangeDetectionStrategy
} from '@angular/core'
import { TopbarComponent } from '../topbar/topbar.component'
import { RouterModule } from '@angular/router'
import { FooterComponent } from '../footer/footer.component'
import { HorizontalNavComponent } from '../horizontal-nav/horizontal-nav.component'

@Component({
  selector: 'horizontal-layout',
  standalone: true,
  imports: [
    TopbarComponent,
    RouterModule,
    FooterComponent,
    HorizontalNavComponent,
  ],
  templateUrl: './horizontal-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class HorizontalLayoutComponent implements OnInit, OnDestroy {
  private render = inject(Renderer2)

  ngOnInit(): void {
    this.render.setAttribute(document.documentElement, 'data-layout', 'topnav')
  }

  ngOnDestroy(): void {
    this.render.removeAttribute(document.documentElement, 'data-layout')
  }

  onToggleMobileMenu() {
    document.getElementById('topnav-menu-content')?.classList.toggle('show')
  }
}
